import { render, staticRenderFns } from "./ManageAcademy.vue?vue&type=template&id=75b1919b&scoped=true"
import script from "./ManageAcademy.vue?vue&type=script&lang=js"
export * from "./ManageAcademy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b1919b",
  null
  
)

export default component.exports